import Img from "components/img/img";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import parse from "html-react-parser";

import "./modalImage.scss";

interface Props {
  onClose: () => void;
  url?: string;
  caption?: string;
  alt?: string;
  localFile?: {
    childImageSharp?: {
      gatsbyImageData: {
        images: {
          fallback: {
            src: string;
            srcSet: string;
            sizes: string;
          };
        };
      };
    };
    publicURL: string;
  };
}

const portalRoot =
  typeof document !== `undefined` ? document.getElementById("portal") : null;

const ModalImage: React.FC<Props> = (props) => {
  useEffect(() => {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    };
  }, []);

  if (!portalRoot) {
    return null;
  }
  return ReactDOM.createPortal(
    <div className="modal-image">
      <button className="modal-image__close" onClick={props.onClose} />
      <div className="modal-image__inner">
        <div className="modal-image__header">{!!props.alt && parse(props.alt)}</div>
        <div className="modal-image__image-container">
          {!!props.url ? (
            <img src={props.url} className="modal-image__image" />
          ) : (
            props.localFile && <Img {...props} className="modal-image__image" />
          )}
        </div>
        <div className="modal-image__footer">
          {!!props.caption && parse(props.caption)}
        </div>
      </div>
    </div>,
    portalRoot
  );
};

export default ModalImage;
